import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, LogIn } from 'lucide-react';
import { useCookieConsent } from '../../contexts/CookieConsentContext';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const CookieWall: React.FC = () => {
    const { consentStatus, openSettings } = useCookieConsent();
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();

    // Show wall only (if rejected) AND (not authenticated)
    if (consentStatus !== 'rejected' || isAuthenticated) {
        return null;
    }

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="fixed inset-0 z-[100] bg-gray-900/95 backdrop-blur-md flex items-center justify-center p-4"
        >
            <div className="max-w-md w-full bg-white dark:bg-gray-900 rounded-3xl overflow-hidden shadow-2xl border border-gray-200 dark:border-gray-800">
                <div className="p-8 text-center">
                    <div className="w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
                        <ShieldAlert className="w-8 h-8 text-red-600 dark:text-red-400" />
                    </div>

                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                        Accès Restricted
                    </h2>

                    <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
                        L'accès au site sans acceptation des cookies est réservé à nos membres. En cas de refus, vous ne pourrez pas accéder aux contenus disponibles sur le site.
                    </p>

                    <div className="space-y-3">
                        <button
                            onClick={() => navigate('/auth/login')}
                            className="w-full py-3 px-4 bg-primary hover:bg-primary-hover text-white font-bold rounded-xl shadow-lg shadow-primary/25 transition-all transform hover:scale-[1.02] flex items-center justify-center gap-2"
                        >
                            <LogIn className="w-5 h-5" />
                            Déjà membre ? Je me connecte
                        </button>

                        <div className="relative my-4">
                            <div className="absolute inset-0 flex items-center">
                                <div className="w-full border-t border-gray-200 dark:border-gray-700"></div>
                            </div>
                            <div className="relative flex justify-center text-sm">
                                <span className="px-2 bg-white dark:bg-gray-900 text-gray-500">Ou</span>
                            </div>
                        </div>

                        <button
                            onClick={openSettings}
                            className="w-full py-3 px-4 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 font-semibold rounded-xl transition-all"
                        >
                            Revoir mes préférences cookies
                        </button>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default CookieWall;
